export interface PeriodoMes {
  inicio: Date;
  fim: Date;
  inicioBanco: string;
  fimBanco: string;
  inicioIso: string;
  fimIso: string;
}

function formatarDataBanco(data: Date): string {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");

  return `${ano}-${mes}-${dia}`;
}

export function obterPeriodoMes(dataReferencia: Date): PeriodoMes {
  const inicio = new Date(
    dataReferencia.getFullYear(),
    dataReferencia.getMonth(),
    1,
    0,
    0,
    0,
    0,
  );
  const fim = new Date(
    dataReferencia.getFullYear(),
    dataReferencia.getMonth() + 1,
    0,
    23,
    59,
    59,
    999,
  );

  return {
    inicio,
    fim,
    inicioBanco: formatarDataBanco(inicio),
    fimBanco: formatarDataBanco(fim),
    inicioIso: inicio.toISOString(),
    fimIso: fim.toISOString(),
  };
}
